//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
import { ContainerForm, ContentForm, TitleForm } from "components/styles";
//#endregion
//#region Components
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import BackToView from "components/BackToView/BackToView";
import StepIndexer from "components/StepIndexer/StepIndexer";
import ToastMessage from "components/ToastMessage/ToastMessage";
import Step1 from "./components/Steps/Step1/Step1";
import Step2 from "./components/Steps/Step2/Step2";
//#endregion
import Footer from "./components/Footer/Footer";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import { STEP_DESCRIPTIONS } from "./utils/constants";
import useMassiveLoadingForm from "./utils/hooks/useMassiveLoadingForm";

const MassiveLoadingForm = () => {
	//#region States
	const [mustCorrect, setMustCorrect] = useState(false);
	const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] = useState(false);
	//#endregion
	const { currentStep, toStep, period, form, errors, errorStack } = useMassiveLoadingForm();
	const views = [
		<Step1
			form={form}
			errors={errors.value}
		/>,
		<Step2
			form={form}
			errors={errors.value}
			errorStack={errorStack.value}
			setCanShowDialogLeavingPage={setCanShowDialogLeavingPage}
		/>,
	];
	return (
		<ContainerForm>
			<HelmetUTP title="Ref. A. - Carga Masiva" />
			<ToastMessage
				variant="error"
				message="Necesitas subir el archivo con los refuerzos que quieres crear."
				hidden={!mustCorrect}
				toggleHidden={() => setMustCorrect(!mustCorrect)}
			/>
			<BackToView
				text="Volver a refuerzos"
				to={ABSOLUTE_PATHS.ACAD_REINFORCE_LIST}
			/>
			<StepIndexer
				descriptions={STEP_DESCRIPTIONS}
				currentStep={currentStep}
			/>
			<TitleForm>Creando refuerzo académico - Carga Masiva</TitleForm>
			<TitleForm>Ciclo lectivo: {period}</TitleForm>
			<ContentForm>
				{views[currentStep - 1] || views[views.length - 1]}
			</ContentForm>
			<Footer
				form={form}
				changeErrors={errors.change}
				setMustCorrect={setMustCorrect}
				errorStackSize={errorStack.value.stack.length}
				fillErrorStack={value => errorStack.set(value)}
				rowCountFile={errorStack.value.rowCountFile}
				currentStep={currentStep}
				toStep={toStep}
				canShowDialogLeavingPage={canShowDialogLeavingPage}
			/>
		</ContainerForm>
	);
};

export default MassiveLoadingForm;
